<template>
  <div class="mini-collaps-categories">
    <div class="list-cat">
      <span class="d-flex flex-lg-row flex-column">
        <button
          class="parent-cat-btn"
          v-for="(item,index) in menuCategoreis"
          :key="index"
          v-b-toggle="'collapse'+index"
        >
          <toggle-open/>
          {{item.category}}
        </button>
      </span>
      <!-- visible -->
      <b-collapse
        v-for="(item,j) in menuCategoreis"
        :key="Math.random()"
        :id="'collapse'+j"
        visible
        accordion="my-accordion"
      >
        <div>
          <ul>
            <li
              v-for="(sub,i) in item.sub"
              :key="i"
              class="pr-0 pr-lg-5"
              @click="$emit('coloseOpen')"
            >
              <router-link :to="'/courses/'+item.en_category+'/'+sub.en_subcategory+'/'+sub.id">
                <i class="flaticon-multi-tab"></i>
                <p>{{sub.subcategory}}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import toggleOpen from "cp/min-component/open-colose.vue";
export default {
  name: "mini-collaps-categories",
  components: {
    toggleOpen
  },
  computed: {
    menuCategoreis() {
      return this.$store.state.categories.filterCat;
    }
  },
  methods: {},
  data() {
    return {};
  }
};
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
@colorBtn: #444;
@textColor: #111;
@iconColor: #222;
@iconHover: #444;
.mobile-mode {
  .tcon {
    position: relative;
    z-index: 77;
  }
  .tcon-transform.tcon {
    position: fixed;
    right: 10px;
  }
  .overwrapper-mobile-mode {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    top: 0;
    visibility: hidden;
    opacity: 0.1;
    background: rgba(53, 63, 70, 0.5);
    z-index: 44;
    transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -webkit-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -moz-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -ms-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -o-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
  }
  .overwrapper-mobile-mode.open {
    visibility: visible;
    opacity: 1;
  }
  .list {
    z-index: 66;
    // width: 420px;
    left: 30px;
    padding-top: 60px;
    text-align: center;
    background: #fff;
    position: fixed;
    right: -420px;
    top: 0;
    visibility: hidden;
    opacity: 0.2;
    transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -webkit-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -moz-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -ms-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    -o-transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    bottom: 0;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
}
.list.open {
  right: 0;
  visibility: visible;
  opacity: 1;
}
.mini-collaps-categories {
  .box-clear;
  .parent-cat-btn {
    .box-clear;
    text-align: right;
    padding-right: 20px;
    border: none;
    box-shadow: none;
    display: block;
    background: #fff;
    color: @colorBtn;
    width: 100%;
    cursor: pointer;
    font-size: 16px;
    height: 34px;
    .line-hover;
  }
  .sub-cat-btn {
    .box-clear;
    text-align: center;
    border: none;
    box-shadow: none;
    background: #fff;
    color: @colorBtn;
    width: 100%;
    cursor: pointer;
    .line-hover;
    font-size: 14px;
    height: 34px;
  }

  ul {
    margin-bottom: 0;
    li {
      text-align: center;
      // position: relative;
      a {
        display: block;
        padding: 10px 0;
        background: #fff;
        position: relative;
        p {
          font-size: 14px;
          margin-bottom: 0;
          color: @textColor;
          display: block;
          text-align: right;
          padding-right: 40px;
          .elips;
        }
        i {
          color: @iconColor;
          position: absolute;
          &:first-child {
            right: 15px;
            top: 15px;
          }
          &:last-child {
            left: 15px;
            top: 15px;
          }
          &:hover {
            color: @iconHover;
          }
        }
        &::before {
          position: absolute;
          content: "";
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          transform-origin: center;
          border-bottom: 2px solid @green;
          transform: scale3d(0, 1, 1);
          transition: all 0.2s cubic-bezier(0, -0.22, 0.18, 1.06);
        }
        &:hover::before {
          transform: scale3d(1, 1, 1);
          transition: transform 0.3s;
        }
      }
    }
  }
}

@media screen and (max-width: 593px) {
  .mobile-mode .list {
    left: 0;
  }
  .mini-collaps-categories .sub-cat-btn {
    font-size: 12px;
  }
}
</style>

<!-- accordion-1.vue -->



// WEBPACK FOOTER //
// src/components/min-component/collaps-categories.vue